import { Directive, ElementRef, HostListener, inject, Input, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[trimInput]',
  standalone: true
})
export class TrimInputDirective {
  @Input() trimInput: boolean = true;
  @Input() emitEvent: boolean = false;
  @Optional() ngControl = inject(NgControl);
  #el = inject(ElementRef);

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: any) {
    if (!!value && this.trimInput) {
      const trimmedValue = value.trim();
      this.ngControl?.control.setValue(trimmedValue, { emitEvent: this.emitEvent });
      this.#el.nativeElement.value = trimmedValue;
    }
  }
}
